import { ReactNode } from 'react';
import styled from 'styled-components';

import { basicTitleTextStyle, ContentNode, ContentNodeRenderer, fonts } from '@dreryk/react-components';

const StyledVisitHistoryItem = styled.div`
   display: flex;
   flex-direction: column;
   gap: 8px;
`;

StyledVisitHistoryItem.displayName = 'StyledVisitHistoryItem';

const StyledVisitHistoryItemHeading = styled.h3`
   ${basicTitleTextStyle}
   font-weight: ${fonts.fontWeightNormal};
   margin: 0;
`;

StyledVisitHistoryItemHeading.displayName = 'StyledVisitHistoryItemHeading';

type StyledVisitHistoryItemProps = {
   readonly children: ReactNode;
   readonly heading: ContentNode;
};

export const VisitHistoryDetailsItem = (props: StyledVisitHistoryItemProps): JSX.Element => {
   return (
      <StyledVisitHistoryItem>
         <StyledVisitHistoryItemHeading>
            <ContentNodeRenderer node={props.heading} />
         </StyledVisitHistoryItemHeading>
         {props.children}
      </StyledVisitHistoryItem>
   );
};
